import { FormData } from '../types';

export type InitialFormValuesType = {
  [key: string]: string | string[] | number | boolean;
};

export interface NewSearchBarProps {
  formEl: React.MutableRefObject<{
    reset: (values: FormData) => void;
  } | null>;
  extraPadding: boolean;
  searchVariables: {
    filter: { [key: string]: undefined | string | boolean | number };
  };
  modalWithFilters?: string;
}

export enum ModalTypeEnum {
  Filters = 'filters',
  Locations = 'locations',
  City = 'city'
}

export type ModalParams = null | {
  initialScreen: ModalTypeEnum;
};

export interface FilterFieldProps {
  submitOnChange?: boolean;
}

export type SelectRefType = { closePopover: () => void } | null;
